import React from 'react';

import DocumentsPage from '../templates/documents';

export const OfficialPassports = (): JSX.Element => {
  return <DocumentsPage title="Official Passports" type="OFFICIAL" />;
};

export default OfficialPassports;
